type FunnelItem = {
  group: string;
  number: number;
  count: number;
};

type FunnelResult = {
  funnelItems: FunnelItem[];
  countTotal: number;
  numberTotal: number;
};

export const transformToFunnelData = (apiData: any[]): FunnelResult => {
  const filteredData = apiData.filter(
    (item) => item.sellerCode !== "no-vendor",
  );
  const grouped = filteredData?.reduce<Record<string, FunnelItem>>(
    (acc, item) => {
      const state = item.state;
      if (!acc[state]) {
        acc[state] = {
          group: state,
          number: item?.total || 0,
          count: 1,
        };
      } else {
        acc[state].number += item?.total || 0;
        acc[state].count += 1;
      }
      return acc;
    },
    {},
  );

  const funnelItems = Object.values(grouped);

  const countTotal = funnelItems.reduce((sum, item) => sum + item.count, 0);
  const numberTotal = funnelItems.reduce((sum, item) => sum + item.number, 0);

  return {
    funnelItems,
    countTotal,
    numberTotal,
  };
};
